import * as types from '@/store/mutation-types'

//通用模块状态控制
//此状态专门控制列表搜索条件
const conditionModule = {
    state: {
        userListParams:{},
        roleListParams:{},
        agentListParams:{},
        departmentExtend:{},
    },

    //激发事件改变state
    mutations: {
        changeUserListParams(state,n){
            state.userListParams = Object.assign({},n)
        },
        changeRoleListParams(state,n){
            state.roleListParams = Object.assign({},n)
        },
        changeAgentListParams(state,n){
            state.agentListParams = Object.assign({},n)
        },
        changeDepartmentExtendParams(state,n){
            state.departmentExtend = Object.assign({},n)
        }
    },

    //异步操作拿远程数据,然后提交事件
    actions: {
        
    },

    //频繁通用计算
    getters: {

    }
}

export default conditionModule;